/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from "react";
import IPMSCustomTable, { Column } from "./IPMSTable";
import { useManageIPMSContext } from "./ManageIPMSContex";
import { QuartersResponse } from "../../model/ipmsmodel";
import { GoalsAssessmentFlagStatusEnumTextCap, USERROLEENUM } from "./constant";
import { getCookieData } from "../../helper/api";
import { useAuth } from "../../context/LoginContext";
import AssessmentFileViewer from "./FileViewerComponent";
import useIPMSApi from "./ipms";
interface GoalsAssessmentReviewProps {
  id: string | null;
  quarterNames: keyof QuartersResponse;
  employeeID: number;
  formType: string;
}

const GoalsAssessmentReview: React.FC<GoalsAssessmentReviewProps> = ({
  quarterNames,
  formType,
}) => {
  const { GetIpmsEmployeeGoalAssessmentData } = useManageIPMSContext();
  const { user } = useAuth();
  const userRole = getCookieData("roleId")
    ? Number(getCookieData("roleId"))
    : user
      ? user.role_id
      : null;
  const { fetchAttachments } = useIPMSApi();

  // ? NEW: State for managing file viewer
  const [attachmentFiles, setAttachmentFiles] = useState<any[]>([]);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const orgcolumns: Column<any>[] = [
    {
      header: "Organizational Goals",
      key: "kra",
      required: false,
      inputType: "text",
      width: "25%",
    },
    {
      header: "Adhering to Goal",
      key: "is_adhered",
      required: true,
      inputType: "selectbox",
      width: "15%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
    },
    {
      header: "Employee Comments",
      key: "self_comment",
      required: false,
      inputType: "textarea",
      width: "30%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
      // enableSpeech: true,
    },
    {
      header: "Manager Comments",
      key: "mgr_comment",
      required: false,
      inputType: "textarea",
      width: "30%",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
      // enableSpeech: true,
    },
  ];

  const softGoalcolumns: Column<any>[] = [
    {
      header: "Soft Goals",
      key: "kra",
      required: false,
      inputType: "text",
      width: "20%",
    },
    {
      header: "Employee's Rating",
      key: "self_rating",
      required: true,
      inputType: "selectbox",
      width: "12%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
    },
    {
      header: "Manager Rating",
      key: "mgr_rating",
      required: true,
      inputType: "selectbox",
      width: "12%",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
    },
    {
      header: "Employee Comments",
      key: "self_comment",
      required: false,
      inputType: "textarea",
      width: "28%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
      // enableSpeech: true,
    },
    {
      header: "Manager Comments",
      key: "mgr_comment",
      required: false,
      inputType: "textarea",
      width: "28%",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
      // enableSpeech: true,
    },
  ];

  const kraGoalcolumns: Column<any>[] = [
    {
      header: "KRA",
      key: "kra",
      required: false,
      inputType: "text",
      width: "12%",
    },
    {
      header: "KPI/Description",
      key: "description",
      required: false,
      inputType: "text",
      width: "15%",
    },
    {
      header: "% Weight age",
      key: "weightage",
      required: false,
      inputType: "text",
      width: "4%",
    },
    {
      header: "Target Date",
      key: "target_date",
      required: false,
      inputType: "text",
      width: "7%",
    },
    {
      header: "% Goal Met",
      key: "percent_met",
      required: true,
      inputType: "input",
      width: "5%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
    },
    {
      header: "Employee's Rating",
      key: "self_rating",
      required: true,
      inputType: "selectbox",
      width: "10%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
    },
    {
      header: "Manager Rating",
      key: "mgr_rating",
      required: true,
      inputType: "selectbox",
      width: "10%",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
    },
    {
      header: "Employee Comments",
      key: "self_comment",
      required: false,
      inputType: "textarea",
      width: "20%",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
      enableHoverPopup: true,
      // enableSpeech: true,
    },
    {
      header: "Manager Comments",
      key: "mgr_comment",
      required: false,
      inputType: "textarea",
      width: "17%",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
      enableHoverPopup: true,
      // enableSpeech: true,
    },
  ];

  const othercolumns: Column<any>[] = [
    {
      header: "Employee Extra Inputs",
      key: "emp_overall_comment",
      required: false,
      inputType: "textarea",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
      // enableSpeech: true,
    },
    {
      header: "Manager Extra Inputs",
      key: "mgr_overall_comment",
      required: false,
      inputType: "textarea",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
      // enableSpeech: true,
    },
  ];

  const bonuscolumns: Column<any>[] = [
    {
      header: "Bonus Rating",
      key: "bonus_rating",
      required: true,
      inputType: "rating",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
    },
  ];

  const getGoals =
    GetIpmsEmployeeGoalAssessmentData &&
    quarterNames &&
    GetIpmsEmployeeGoalAssessmentData[quarterNames];

  const header =
    getGoals && typeof getGoals !== "string" && "header" in getGoals
      ? getGoals.header
      : null;

  const getStatusNumber = (status: string | undefined) => {
    if (!status) return 0;
    switch (status.toUpperCase()) {
      case "READY":
        return GoalsAssessmentFlagStatusEnumTextCap.READY; // Assuming 1 is save
      case "SUBMITTED":
        return GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED; // Assuming 2 is submit
      case "APPROVED":
        return GoalsAssessmentFlagStatusEnumTextCap.APPROVED; // Assuming 3 is approved
      case "COMPLETED":
        return GoalsAssessmentFlagStatusEnumTextCap.COMPLETED; // Assuming 4 is rejected
      default:
        return "";
    }
  };

  const assessmentStatusNum = getStatusNumber(header?.assessment_status);
  const loadAttachments = async (reviewId: number) => {
    try {
      setLoadingFiles(true);
      console.log(
        "[GoalsAssessmentReview] Loading attachments for review:",
        reviewId,
      );

      const response = await fetchAttachments(reviewId);

      if (response?.status && response?.data?.attachments) {
        setAttachmentFiles(response.data.attachments);
        console.log(
          "[GoalsAssessmentReview] Attachments loaded:",
          response.data.attachments,
        );
      } else {
        setAttachmentFiles([]);
      }
    } catch (error) {
      console.error(
        "[GoalsAssessmentReview] Error loading attachments:",
        error,
      );
      setAttachmentFiles([]);
    } finally {
      setLoadingFiles(false);
    }
  };
  useEffect(() => {
    if (formType === "ManageInput" && header?.id) {
      loadAttachments(header.id);
    }
  }, [header?.id, formType]);

  return (
    <div>
      {/* Supporting Documents Block */}
      {formType === "ManageInput" && (
        <div className="mt-6 mb-6">
          <p className="text-white bg-gray-500 text-center font-medium rounded-t-lg">
            Supporting Documents
          </p>
          <div className="p-4 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-b-lg">
            {loadingFiles ? (
              <p className="text-center text-gray-600 dark:text-gray-400">
                Loading files...
              </p>
            ) : attachmentFiles.length > 0 ? (
              <AssessmentFileViewer
                reviewId={header?.id || 0}
                employeeId={0}
                enableDownload={true}
              />
            ) : (
              <p className="text-center text-gray-600 dark:text-gray-400 italic">
                No supporting documents uploaded by employee
              </p>
            )}
          </div>
        </div>
      )}
      <p className="text-white bg-gray-500 text-center font-medium rounded-t-lg">
        REVIEW OF ORGANIZATIONAL GOALS
      </p>
      {getGoals && typeof getGoals !== "string" && "org_goals" in getGoals && (
        <IPMSCustomTable
          columns={orgcolumns}
          data={getGoals.org_goals}
          tableKeyName="org_goals"
          quarterNameData={quarterNames as string}
          roles={userRole}
          assessmentStatus={header?.assessment_status ?? ""}
          formTypeRule={formType}
          assessment_scale={
            getGoals && typeof getGoals !== "string"
              ? (getGoals as any).assessment_scale
              : []
          }
        />
      )}
      <p className="text-white bg-gray-500 text-center font-medium rounded-t-lg">
        REVIEW OF SOFT GOALS
      </p>
      {getGoals && typeof getGoals !== "string" && "soft_goals" in getGoals && (
        <IPMSCustomTable
          columns={softGoalcolumns}
          data={getGoals.soft_goals}
          tableKeyName="soft_goals"
          quarterNameData={quarterNames as string}
          roles={userRole}
          assessmentStatus={header?.assessment_status ?? ""}
          formTypeRule={formType}
          assessment_scale={
            getGoals && typeof getGoals !== "string"
              ? (getGoals as any).assessment_scale
              : []
          }
        />
      )}
      <p className="text-white bg-gray-500 text-center font-medium rounded-t-lg">{`REVIEW OF EMPLOYEE KRA's`}</p>
      {getGoals && typeof getGoals !== "string" && "goals" in getGoals && (
        <IPMSCustomTable
          columns={kraGoalcolumns}
          data={getGoals.goals}
          tableKeyName="goals"
          quarterNameData={quarterNames as string}
          roles={userRole}
          assessmentStatus={header?.assessment_status ?? ""}
          formTypeRule={formType}
          assessment_scale={
            getGoals && typeof getGoals !== "string"
              ? (getGoals as any).assessment_scale
              : []
          }
        />
      )}
      <p className="pb-10 font-medium text-black dark:text-gray-100">
        Please input any other achievements which you want to highlight in this
        Quarterly review (Note: It should not be the part of any of your goals
        above).
      </p>
      <p className="text-white bg-gray-500 text-center font-medium rounded-t-lg">
        Other
      </p>
      {header && (
        <IPMSCustomTable
          columns={othercolumns}
          data={[header]}
          tableKeyName="header"
          roles={userRole}
          assessmentStatus={header?.assessment_status ?? ""}
          quarterNameData={quarterNames as string}
          formTypeRule={formType}
          assessment_scale={
            getGoals && typeof getGoals !== "string"
              ? (getGoals as any).assessment_scale
              : []
          }
        />
      )}

      {formType === "ManageInput" && (
        <p className="text-white bg-gray-500 text-center font-medium rounded-t-lg">
          Bonus Rating
        </p>
      )}
      {formType === "ManageInput" && header && (
        <IPMSCustomTable
          columns={bonuscolumns}
          data={[header]}
          tableKeyName="header"
          roles={userRole}
          assessmentStatus={header?.assessment_status ?? ""}
          quarterNameData={quarterNames as string}
          formTypeRule={formType}
          assessment_scale={
            getGoals && typeof getGoals !== "string"
              ? (getGoals as any).assessment_scale
              : []
          }
        />
      )}

      {/* {assessmentStatusNum && [GoalsAssessmentFlagStatusEnumTextCap.APPROVED, GoalsAssessmentFlagStatusEnumTextCap.COMPLETED].includes(assessmentStatusNum) && <p className="text-red-600">
        Manager KRA Rating: {header?.mgr_rating_kra ?? 0} ,
        Manager SoftGoal Rating: {header?.mgr_rating_soft ?? 0} ,
        Bonus Rating: {header?.bonus_rating ?? 0} ,
        Final Rating: {header?.final_rating ?? 0} */}
      {/* FIX: Employee ratings shown from SUBMITTED onwards (employee can see their own ratings immediately) */}
      {assessmentStatusNum &&
        [
          GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED,
          GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
          GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
        ].includes(assessmentStatusNum) && (
          <p className="text-red-600">
            Employee KRA Rating: {header?.emp_rating_kra ?? 0} , Employee
            SoftGoal Rating: {header?.emp_rating_soft ?? 0}
          </p>
        )}

      {/* FIX: Manager ratings shown only after manager has approved */}
      {assessmentStatusNum &&
        [
          GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
          GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
        ].includes(assessmentStatusNum) && (
          <p className="text-red-600">
            Manager KRA Rating: {header?.mgr_rating_kra ?? 0} , Manager SoftGoal
            Rating: {header?.mgr_rating_soft ?? 0} , Bonus Rating:{" "}
            {header?.bonus_rating ?? 0}
            {/* Final Rating label + value shown only in Q4 */}
            {quarterNames === "q4" && (
              <> , Final Rating: {header?.final_rating ?? 0}</>
            )}
          </p>
        )}
    </div>
  );
};
//       </p>}
//     </div>
//   );
// };

export default GoalsAssessmentReview;
